import { ITemplateLeftNav } from '../template-designer';

export const reportAdvanceLeftNav: ITemplateLeftNav = {
  settings: {
    isSource: false,
    title: 'Settings',
    subNav: [
      {
        title: 'Time ranges',
        icon: 'calendar',
        id: 'timeRange',
        type: 'time',
        path: 'settings',
        count: 0,
      },
      {
        title: 'Variables',
        icon: 'cube',
        id: 'variable',
        type: 'variable',
        path: 'settings',
        count: 0,
      },
    ],
  },
  datasources: {
    isSource: true,
    title: 'Data sources',
    subNav: [],
  },
};
